module.exports = __webpack_public_path__ + "media/background_loop.1bfcbc7a.mp3";